import React, { useState } from "react";
import { useStateValue } from "../../../StateProvider";
import { Avatar, Input } from "@material-ui/core";
import VideocamIcon from "@material-ui/icons/Videocam";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import InsertEmoticonIcon from "@material-ui/icons/InsertEmoticon";
import FormData from "form-data";
import axios from "../../../services/httpServices";
import "./messenger.css";

const Messenger = () => {
  const [{ user }, dispatch] = useStateValue();
  const [input, setInput] = useState("");
  const [image, setImage] = useState(null);

  const savePost = async (postData) => {
    await axios.post("/upload/post", postData).then((res) => {
      console.log(res);
    });
  };

  const handleChange = (e) => {
    if (e.target.files[0]) setImage(e.target.files[0]);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (image) {
      const imgform = new FormData();
      imgform.append("file", image, image.name);
      axios
        .post("/upload/image", imgform, {
          headers: {
            accept: "application/json",
            "Accept-Language": "en-US,en;q=0.8",
            "Content-Type": `multipart/form-data;
boundary=${imgform._boundary}`,
          },
        })
        .then((res) => {
          const postData = {
            text: input,
            imgName: res.data.filename,
            user: user.displayName,
            avatar: user.photoURL,
            timestamp: Date.now(),
          };
          savePost(postData);
        });
    } else {
      const postData = {
        text: input,
        user: user.displayName,
        avatar: user.photoURL,
        timestamp: Date.now(),
      };
      savePost(postData);
    }
    setInput("");
    setImage(null);
  };
  return (
    <div className="messenger-wrapper">
      <div className="messenger-top">
        <Avatar src={user.photoURL} />
        <form>
          <input
            type="text"
            className="messenger__input"
            placeholder="What's on your mind?"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <Input
            type="file"
            className="messenger__fileSelector"
            onChange={handleChange}
          />
          <button onClick={handleSubmit} type="submit">
            Hidden
          </button>
        </form>
      </div>
      <div className="messenger-buttom">
        <div className="messenger__option">
          <VideocamIcon style={{ color: "red" }} />
          <h3>Live Video</h3>
        </div>
        <div className="messenger__option">
          <PhotoLibraryIcon style={{ color: "green" }} />
          <h3>Photo/Video</h3>
        </div>
        <div className="messenger__option">
          <InsertEmoticonIcon style={{ color: "orange" }} />
          <h3>Feeling/Activity</h3>
        </div>
      </div>
    </div>
  );
};

export default Messenger;
